import { call, put, takeLatest } from 'redux-saga/effects';
import request from '../../../utils/request';
import { actions } from './slice';
import { BACKEND_URL } from '../../../variables';

const { search, searchSuccess, searchSuccessNext, searchNext, searchError } = actions;

export function searchRequest(api = request) { 
    return function* (action) {
        const language = localStorage.getItem("lang") || 'en'
        const requestURL = `${BACKEND_URL}/publications?page=${action.payload.page || 0}&size=20&lng=${language}`;
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(action.payload),
        };
        try {
            const data: object[] = yield call(api, requestURL, options);
            if(action.payload.isCurrent  === false){
                yield put(searchSuccessNext(data));
            } else {
                yield put(searchSuccess(data));
            }   
            sessionStorage.setItem(`Search_data_${action.payload.page || 0}`, JSON.stringify(data))
            const removeItem = sessionStorage.getItem(`Search_data_${action.payload.page -10}`)
            if(removeItem && action.payload.page-10 !==0){    
                sessionStorage.removeItem(`Search_data_${action.payload.page -10}`)
            }
            const removeFromLastItem = sessionStorage.getItem(`Search_data_${action.payload.page +10}`)
            if(removeFromLastItem && action.payload.page+10 !==15107){    
                sessionStorage.removeItem(`Search_data_${action.payload.page + 10}`)
            }
        } catch (error: any) {
            yield put(searchError(error.response));
        }
    };
}

export default function* rootSaga() {
    yield takeLatest(search.type, searchRequest(request));
    yield takeLatest(searchNext.type, searchRequest(request));
}
